import { ButtonList } from '@dixa/lib-shared-habla';

import { actions as personalActions } from 'components/settings/actions/personal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioSelectors } from '../../elevio.reducer/selectors';
import {
  ElevioLanguage,
  SelectedLanguageMode,
} from '../../types/elevio.actions';

export function LanguagePickerDropdown(): JSX.Element {
  const conversationId = useAppSelector(elevioSelectors.conversation.id);
  const {
    availableLanguages,
    defaultLanguage,
    detectedLanguages,
    selectedLanguageId,
    selectedLanguageMode,
  } = useAppSelector(elevioSelectors.suggestion.languages);
  const detectedLanguageId = useAppSelector(
    elevioSelectors.suggestion.getDetectedLanguage(conversationId),
  );
  const detectedLanguage = detectedLanguageId
    ? detectedLanguages[detectedLanguageId]
    : null;

  const dispatch = useAppDispatch();

  if (availableLanguages.loading) {
    return (
      <ButtonList.Item isDisabled>Fetching Elevio languages...</ButtonList.Item>
    );
  }

  function setLanguageId({
    language,
    mode,
  }: {
    language: ElevioLanguage | undefined;
    mode: SelectedLanguageMode;
  }) {
    if (!conversationId) return;

    const elevioSelectedLanguage =
      mode === 'autoDetectedLanguage' || mode === 'defaultLanguage' || !language
        ? mode
        : language.id;
    dispatch(
      personalActions.personalChangedElevioSelectedLanguage({
        elevioSelectedLanguage,
      }),
    );
  }

  return (
    <ButtonList>
      <ButtonList.Item
        onClick={() =>
          setLanguageId({
            language: detectedLanguage,
            mode: 'autoDetectedLanguage',
          })
        }
        isSelected={selectedLanguageMode === 'autoDetectedLanguage'}
      >
        {detectedLanguage
          ? `Auto detected (${detectedLanguage?.nativeName})`
          : `Auto detected (Undetected)`}
      </ButtonList.Item>
      <ButtonList.Item
        onClick={() =>
          setLanguageId({ language: defaultLanguage, mode: 'defaultLanguage' })
        }
        isSelected={selectedLanguageMode === 'defaultLanguage'}
      >
        {defaultLanguage.nativeName} (Default)
      </ButtonList.Item>

      {availableLanguages.results
        ?.filter((lang) => lang.id !== defaultLanguage.id)
        .map((lang) => (
          <ButtonList.Item
            key={lang.id}
            isSelected={lang.id === selectedLanguageId}
            isDisabled={false}
            onClick={() =>
              setLanguageId({ language: lang, mode: 'userSelectedLanguage' })
            }
          >
            {lang.nativeName}
          </ButtonList.Item>
        ))}
    </ButtonList>
  );
}
